import i18next from '../services/i18n';

export default (lat, lng) =>
  `${lat?.toLocaleString(i18next.language, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })}; ${lng?.toLocaleString(i18next.language, {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
  })}`;
